function getHeaderOffset() {
  const styles = getComputedStyle(document.documentElement);
  const header = document.getElementById('masthead');
  // Measure the actual fixed header, including an admin-bar offset.
  const rect = header?.getBoundingClientRect();
  const headerBottom =
    rect?.height > 0
      ? Math.max(0, rect.bottom)
      : parseFloat(styles.getPropertyValue('--header-height')) || 0;
  return headerBottom + (parseFloat(styles.getPropertyValue('--scroll-offset-adjustment')) || 0);
}
function targetFor(hash) {
  if (!hash || hash === '#') return null;
  let id = hash.slice(1);
  try {
    id = decodeURIComponent(id);
  } catch {
    /* Keep literal malformed IDs. */
  }
  // Support both Unicode/manual IDs and previously generated percent-encoded IDs.
  return document.getElementById(id) || document.getElementById(hash.slice(1));
}
function focusTarget(target) {
  if (
    !target.hasAttribute('tabindex') &&
    !target.matches('a[href], button, input, select, textarea')
  ) {
    target.setAttribute('tabindex', '-1');
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
  }
  target.focus({ preventScroll: true });
}
function moveTo(target) {
  target
    .querySelectorAll('img[data-src], img[data-srcset], source[data-srcset]')
    .forEach((image) => {
      if (image.dataset.src) {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }
    });
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({
    top: target.getBoundingClientRect().top + window.scrollY - getHeaderOffset(),
    behavior: reducedMotion ? 'instant' : 'smooth',
  });
  focusTarget(target);
}
function handleAnchorClick(event, link) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return;
  if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
  const url = new URL(link.href, document.baseURI);
  if (
    url.origin !== window.location.origin ||
    url.pathname !== window.location.pathname ||
    url.search !== window.location.search
  )
    return;
  const target = targetFor(url.hash);
  if (!target) return;
  event.preventDefault();
  history.replaceState(null, '', url.pathname + url.search + url.hash);
  moveTo(target);
}
export function initSmoothScroll() {
  // Delegate so links added after fetching JSON also work.
  if (document.documentElement.dataset.smoothScrollInitialized) return;
  document.documentElement.dataset.smoothScrollInitialized = 'true';
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    handleAnchorClick(event, link);
  });
}
export function scrollOnLoadHash() {
  const target = targetFor(window.location.hash);
  if (target) moveTo(target);
}
